import {
  Stack,
  StackProps
} from "@mui/material"

import { Loading } from "components/controls/loading"

import { KojinSummary, useKojinSummary } from "./components/kojinSummary"

type KojinSummaryPageProps = {
  container: ReturnType<typeof useKojinSummary>
} & StackProps
export const KojinSummaryPage = ({
  container,
  ...others
}: KojinSummaryPageProps) => {
  return (
    <>
      { container.loading && <Loading/> }

      <Stack
        direction='column'
        position="relative"
        overflow="auto"
        height="100%"
        boxSizing="border-box"
        {...others}
      >
        <KojinSummary
          summary={container}
          position="relative"
        />
      </Stack>
    </>
  )
}
